import React from 'react';
import Button from "./Button";

const About = props => {

  return (
    <section className="cta">
      <h1>McSoftware S.p.a.</h1>
      <h2>
        Via Silvio Spaventa, 43<br/>
        06040, Triponzo (PG)<br/>
        P. IVA 0987654321<br/>
        C. Sociale: 2€
      </h2>
    </section>
  )
};

export default About;
